import { jsx as o } from "react/jsx-runtime";
import { T as m, f as g, h as x, g as _, e as y, c as T, d as p, b as u } from "../Table-Cpj5cmWs.js";
import { useRef as f, useState as C, useEffect as H } from "react";
import { c as a } from "../clsx-OuTLNxxd.js";
import "../GridTable.css?__remix_sideEffect__";const W = "320px",B = "600px",z = "1025px",w = "_isVisuallyHidden_1hm41_52",S = "_tableGroup_1hm41_64",R = "_table_1hm41_64",G = "_tableLabel_1hm41_78",F = "_tableWrapper_1hm41_96",N = "_tableCaption_1hm41_114",M = "_tableRow_1hm41_131",k = "_tableHeader_1hm41_135",v = "_tableColumn_1hm41_135",D = "_tableBody_1hm41_145",L = "_tableCell_1hm41_145",V = "_tableFooter_1hm41_147",E = "_highlight_1hm41_167",j = "_showDividers_1hm41_201",O = "_cellWrapper_1hm41_237",q = "_headingText_1hm41_164",A = "_columnWrapper_1hm41_240",I = "_gridTableWrapper_1hm41_295",J = "_gridTable_1hm41_295",K = "_gridTableRow_1hm41_305",P = "_gridTableColumn_1hm41_309",Q = "_gridTableCaption_1hm41_312",U = "_gridTableHeader_1hm41_313",X = "_gridTableBody_1hm41_314",Y = "_gridTableFooter_1hm41_315",Z = "_gridTableCell_1hm41_319",$ = "_fullWidthMobile_1hm41_322",ee = "_hasMultipleTableBodies_1hm41_331",le = "_mainColumn_1hm41_366",i = {
    mobile: W,
    "mobile-wide": "480px",
    tablet: B,
    "tablet-wide": "800px",
    desktop: z,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: w,
    tableGroup: S,
    table: R,
    tableLabel: G,
    tableWrapper: F,
    tableCaption: N,
    tableRow: M,
    tableHeader: k,
    "tableRow-size--s": "_tableRow-size--s_1hm41_135",
    tableColumn: v,
    "tableRow-size--m": "_tableRow-size--m_1hm41_139",
    tableBody: D,
    tableCell: L,
    tableFooter: V,
    "headingText--mobile": "_headingText--mobile_1hm41_164",
    highlight: E,
    showDividers: j,
    "highlight--green": "_highlight--green_1hm41_220",
    "highlight--amber": "_highlight--amber_1hm41_224",
    "highlight--red": "_highlight--red_1hm41_228",
    "mobile-hide": "_mobile-hide_1hm41_232",
    cellWrapper: O,
    headingText: q,
    columnWrapper: A,
    gridTableWrapper: I,
    gridTable: J,
    gridTableRow: K,
    gridTableColumn: P,
    gridTableCaption: Q,
    gridTableHeader: U,
    gridTableBody: X,
    gridTableFooter: Y,
    gridTableCell: Z,
    fullWidthMobile: $,
    hasMultipleTableBodies: ee,
    mainColumn: le
  },n = ({
    children: e,
    className: l,
    mobileColumns: t,
    label: b,
    ...d
  }) => {
    const s = f(null),[r, c] = C(1);
    return H(() => {
      if (s.current) {
        const h = s.current.getElementsByClassName(
          i.gridTableBody
        );
        c(h ? h.length : 1);
      }
    }, [s.current]), /* @__PURE__ */o(
      "div",
      {
        "aria-label": b,
        className: i.gridTableWrapper,
        style: {
          "--gridWidth": r + 1,
          ...(r === 1 ? { gridTemplateColumns: "auto" } : {}),
          "--mobileColumns": t
        },
        children: /* @__PURE__ */o(
          m,
          {
            ref: s,
            className: a(i.gridTable, l, {
              [i.hasMultipleTableBodies]: r > 1
            }),
            ...d,
            children: e
          }
        )
      }
    );
  },te = ({ children: e, className: l, ...t }) => /* @__PURE__ */o(g, { className: a(i.gridTableRow, l), ...t, children: e }),ie = ({
    children: e,
    className: l,
    isMain: t,
    ...b
  }) => /* @__PURE__ */o(
    x,
    {
      className: a(
        i.gridTableColumn,
        {
          [i.mainColumn]: t
        },
        l
      ),
      ...b,
      children: e
    }
  ),oe = ({
    children: e,
    isFullWidthMobile: l,
    isMain: t,
    className: b,
    order: d,
    start: s,
    ...r
  }) => /* @__PURE__ */o(
    _,
    {
      style: { "--cellOrder": d, "--start": s },
      className: a(
        i.gridTableCell,
        {
          [i.fullWidthMobile]: l,
          [i.mainColumn]: t
        },
        b
      ),
      ...r,
      children: e
    }
  ),ae = ({
    children: e,
    className: l,
    ...t
  }) => /* @__PURE__ */o(y, { ...t, className: a(i.gridTableFooter, l), children: e }),ne = ({ children: e, className: l, ...t }) => /* @__PURE__ */o(T, { ...t, className: a(i.gridTableHeader, l), children: e }),se = ({ children: e, className: l, ...t }) => /* @__PURE__ */o(p, { className: a(i.gridTableBody, l), ...t, children: e }),be = ({
    children: e,
    className: l,
    ...t
  }) => /* @__PURE__ */o(u, { className: a(i.gridTableCaption, l), ...t, children: e });
n.Caption = be;
n.Row = te;
n.Head = ne;
n.Body = se;
n.Column = ie;
n.Cell = oe;
n.Footer = ae;
export {
  n as GridTable };